import { render, staticRenderFns } from "./ShipmentsCard.vue?vue&type=template&id=2d29b29d&"
import script from "./ShipmentsCard.vue?vue&type=script&lang=js&"
export * from "./ShipmentsCard.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports